import { Component, OnInit } from '@angular/core';
import { ToastService } from 'src/app/core/toast/toast.service';
import { WizardPageComponent } from 'src/app/core/wizard/wizard-page-component';
import { UntypedFormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { PdfExportService } from 'src/app/core/service/pdf-export.service';
import { DynamicPdfService, MapSearchPdfData } from 'src/app/core/service/dynamic-pdf.service';

@Component({
  standalone: false,
  selector: 'mtn-map-search-pdf-page',
  templateUrl: './map-search-pdf-page.component.html',
  styleUrls: ['./map-search-pdf-page.component.scss']
})
export class MapSearchPdfPageComponent extends WizardPageComponent<any> implements OnInit {
  key = 'map-search-pdf';
  title = 'Map Search Report Preview';
  exportPdfButtonText = 'Export PDF';
  exportPdfButton = true;
  closeButtonText = 'Close';
  form = new UntypedFormGroup({});

  exportDate = 'October  14,2025';
  exportTime = '2:34 PM EST';
  analysisDescription = '';
  capturedMapImage: string = '';
  
  storeLegendItems: string[] = [];
  storeLegendItemsSecondary: string[] = [];
  
  filterRegion = '';
  filterFits = '';
  filterStatus = '';
  showActiveFilters = false;

  areaSquareFeet = '2,847,392 sq ft';
  areaAcres = '65.3 acres';
  perimeterFeet = '8,420 ft';
  perimeterMiles = '1.59 miles';
  centerPointLat = '41.88430N';
  centerPointLong = '87.63240W';
  
  filteredStores: any[] = [];
  totalStoreCount = 0;
  showPolygonAnalysis = false;
  polygonDrawnTime: number = 0;
  polygonTimeout = 15000; // 15 seconds

  // filteredStores = [
  //   { storeName: 'Jewel-Osco #3042', banner: 'Jewel-Osco', format: 'Conventional', address: '1224 S Wabash Ave' },
  //   { storeName: 'Mariano\'s Fresh Market', banner: 'Mariano\'s', format: 'Conventional', address: '333 E Benton Pl' },
  //   { storeName: 'Whole Food Market', banner: 'Whole Foods', format: 'Natural Foods', address: '30 W Huron St' },
  //   { storeName: 'Aldi Store #94', banner: 'Aldi', format: 'Natural Foods', address: '30 W Huron St' },
  //   { storeName: 'Jewel-Osco #3042', banner: 'Jewel-Osco', format: 'Conventional', address: '1224 S Wabash Ave' },
  //   { storeName: 'Mariano\'s Fresh Market', banner: 'Mariano\'s', format: 'Conventional', address: '333 E Benton Pl' },
  //   { storeName: 'Jewel-Osco #3042', banner: 'Jewel-Osco', format: 'Conventional', address: '1224 S Wabash Ave' },
  //   { storeName: 'Mariano\'s Fresh Market', banner: 'Mariano\'s', format: 'Conventional', address: '333 E Benton Pl' },
  //   { storeName: 'Whole Food Market', banner: 'Whole Foods', format: 'Natural Foods', address: '30 W Huron St' },
  //   { storeName: 'Aldi Store #94', banner: 'Aldi', format: 'Natural Foods', address: '30 W Huron St' },
  //   { storeName: 'Jewel-Osco #3042', banner: 'Jewel-Osco', format: 'Conventional', address: '1224 S Wabash Ave' },
  //   { storeName: 'Mariano\'s Fresh Market', banner: 'Mariano\'s', format: 'Conventional', address: '333 E Benton Pl' },
  //   { storeName: 'Whole Food Market', banner: 'Whole Foods', format: 'Natural Foods', address: '30 W Huron St' },
  //   { storeName: 'Mariano\'s Fresh Market', banner: 'Mariano\'s', format: 'Conventional', address: '333 E Benton Pl' },
  //   { storeName: 'Whole Food Market', banner: 'Whole Foods', format: 'Natural Foods', address: '30 W Huron St' },
  //   { storeName: 'Aldi Store #94', banner: 'Aldi', format: 'Natural Foods', address: '30 W Huron St' },
  //   { storeName: 'Whole Food Market', banner: 'Whole Foods', format: 'Natural Foods', address: '30 W Huron St' },
  //   { storeName: 'Aldi Store #94', banner: 'Aldi', format: 'Natural Foods', address: '30 W Huron St' },
  //   { storeName: 'Whole Food Market', banner: 'Whole Foods', format: 'Natural Foods', address: '30 W Huron St' },
  //   { storeName: 'Aldi Store #94', banner: 'Aldi', format: 'Natural Foods', address: '30 W Huron St' }
  // ];
  // totalStoreCount = 23;

  constructor(
    private toaster: ToastService,
    private pdfExportService: PdfExportService,
    private dynamicPdfService: DynamicPdfService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initializeExportDate();
    this.initializeUserDescription();
    this.initializeStoreLegend();
    this.getMapDataFromGlobalState();
    this.initializeMapCenterCoordinates();
    
    // Get global polygon timer
    this.polygonDrawnTime = (window as any).polygonDrawnTime || 0;
    this.showPolygonAnalysis = false;
    this.checkPolygonAnalysis();
    
    // Debug: Check what's available
    console.log('PDF Component - capturedMapImage:', this.capturedMapImage);
    console.log('PDF Component - window.capturedMapImage:', (window as any).capturedMapImage);
  }

  getMapDataFromGlobalState(): void {
    // Try to get map data from window object or global state
    const globalMapData = (window as any).currentMapData;
    if (globalMapData) {
      this.wizard.model.selectionMode = globalMapData.selectionMode;
      this.wizard.model.polygonArea = globalMapData.polygonArea;
      this.wizard.model.centerPoint = globalMapData.centerPoint;
      this.wizard.model.perimeterFeet = globalMapData.perimeterFeet;
      this.wizard.model.perimeterMiles = globalMapData.perimeterMiles;
      console.log('Retrieved map data from global state:', globalMapData);
    }
    
    // Get captured map image
    const capturedMap = (window as any).capturedMapImage;
    if (capturedMap) {
      this.capturedMapImage = capturedMap;
      console.log('Retrieved captured map image');
    } else {
      // Try to capture map now
      this.captureMapNow();
    }
  }

  async captureCurrentMapState() {
    try {
      const mapSelectors = ['mtn-map', '.mtn-map', '[class*="map"]', 'google-map', '.map-container'];
      let mapElement = null;
      
      for (const selector of mapSelectors) {
        mapElement = document.querySelector(selector);
        if (mapElement) {
          console.log('Capturing current map with selector:', selector);
          break;
        }
      }
      
      if (mapElement) {
        const html2canvas = (await import('html2canvas')).default;
        // Hide toolbar elements before capture
        const toolbars = document.querySelectorAll('mtn-maps-controls-toolbar, mtn-filter-toolbar, [class*="toolbar"], [class*="control"]');
        const originalStyles: { element: Element, display: string }[] = [];
        
        toolbars.forEach(toolbar => {
          const computedStyle = window.getComputedStyle(toolbar as HTMLElement);
          originalStyles.push({ element: toolbar, display: computedStyle.display });
          (toolbar as HTMLElement).style.display = 'none';
        });
        
        const canvas = await html2canvas(mapElement as HTMLElement, {
          useCORS: true,
          allowTaint: true,
          scale: 2,
          logging: false
        });
        
        // Restore original styles
        originalStyles.forEach(({ element, display }) => {
          (element as HTMLElement).style.display = display;
        });
        const mapImage = canvas.toDataURL('image/png');
        this.capturedMapImage = mapImage;
        console.log('Current map state captured for PDF');
      } else {
        console.error('No map element found for capture');
      }
    } catch (error) {
      console.error('Map capture failed:', error);
    }
  }

  async captureMapNow() {
    // Find and store map reference
    const mapElements = Array.from(document.querySelectorAll('mtn-map, [data-map-id], .gm-style'));
    for (const element of mapElements) {
      if ((element as any).__ngContext__ && Array.isArray((element as any).__ngContext__)) {
        const contexts = (element as any).__ngContext__;
        for (let i = 0; i < contexts.length; i++) {
          if (contexts[i] && contexts[i].map && contexts[i].map.getBounds) {
            (window as any).currentMap = contexts[i].map;
            console.log('Map instance found and stored');
            break;
          }
        }
      }
    }
    
    await this.captureCurrentMapState();
  }

  checkPolygonAnalysis(): void {
    const hasActivePolygon = this.hasActivePolygonOnMap();
    const hasSelectedStores = this.totalStoreCount > 0;
    const isWithinTimeLimit = this.isPolygonWithinTimeLimit();
    
    console.log('PDF Component - Has active polygon:', hasActivePolygon, 'Has stores:', hasSelectedStores, 'Within time limit:', isWithinTimeLimit);
    
    this.showPolygonAnalysis = hasActivePolygon && hasSelectedStores && isWithinTimeLimit;
    
    if (this.showPolygonAnalysis) {
      const globalMapData = (window as any).currentMapData;
      const currentSelectionMode = globalMapData?.selectionMode || this.wizard?.model?.selectionMode;
      const currentPolygonArea = globalMapData?.polygonArea;
      
      if (currentSelectionMode === 'LASSO' && currentPolygonArea) {
        this.updatePolygonMetrics(currentPolygonArea);
      } else if (currentSelectionMode === 'RING') {
        this.updateRingMetrics();
      }
    }
  }
  
  hasActivePolygonOnMap(): boolean {
    const globalMapData = (window as any).currentMapData;
    const currentSelectionMode = globalMapData?.selectionMode;
    const currentPolygonArea = globalMapData?.polygonArea;
    
    if (currentSelectionMode === 'LASSO') {
      const hasArea = currentPolygonArea > 0;
      if (hasArea) {
        // Check if this is a new polygon (different area or no previous timer)
        const lastPolygonArea = (window as any).lastPolygonArea;
        if (!lastPolygonArea || lastPolygonArea !== currentPolygonArea) {
          (window as any).polygonDrawnTime = Date.now();
          (window as any).lastPolygonArea = currentPolygonArea;
        }
        this.polygonDrawnTime = (window as any).polygonDrawnTime;
        return hasArea;
      } else {
        (window as any).polygonDrawnTime = 0;
        (window as any).lastPolygonArea = 0;
        this.polygonDrawnTime = 0;
        return false;
      }
    } else if (currentSelectionMode === 'RING') {
      // For ring, reset timer each time (since ring can be redrawn)
      (window as any).polygonDrawnTime = Date.now();
      this.polygonDrawnTime = (window as any).polygonDrawnTime;
      return true;
    } else {
      (window as any).polygonDrawnTime = 0;
      (window as any).lastPolygonArea = 0;
      this.polygonDrawnTime = 0;
      return false;
    }
  }
  
  isPolygonWithinTimeLimit(): boolean {
    if (!this.polygonDrawnTime) return false;
    const currentTime = Date.now();
    return (currentTime - this.polygonDrawnTime) <= this.polygonTimeout;
  }

  updatePolygonMetrics(areaInSquareMeters: number): void {
    const areaInSquareFeet = areaInSquareMeters * 10.764;
    const areaInAcres = areaInSquareMeters * 0.000247105;
    
    this.areaSquareFeet = `${Math.round(areaInSquareFeet).toLocaleString()} sq ft`;
    this.areaAcres = `${areaInAcres.toFixed(1)} acres`;
    
    // Update center point if available
    const centerPoint = this.wizard?.model?.centerPoint || this.wizard?.model?.mapCenter;
    if (centerPoint) {
      this.centerPointLat = `${centerPoint.lat.toFixed(4)}`;
      this.centerPointLong = `${centerPoint.lng.toFixed(4)}`;
    }
  }

  updateRingMetrics(): void {
    const perimeterFeet = this.wizard?.model?.perimeterFeet;
    const perimeterMiles = this.wizard?.model?.perimeterMiles;
    const centerPoint = this.wizard?.model?.centerPoint || this.wizard?.model?.mapCenter;
    
    if (perimeterFeet && perimeterMiles) {
      this.perimeterFeet = `${Math.round(perimeterFeet).toLocaleString()} ft`;
      this.perimeterMiles = `${perimeterMiles.toFixed(2)} miles`;
    }
    
    if (centerPoint) {
      this.centerPointLat = `${centerPoint.lat.toFixed(4)}`;
      this.centerPointLong = `${centerPoint.lng.toFixed(4)}`;
    }
  }

  onLoad(): Observable<any> {
    return of(null);
  }

  onExportPdf(): Observable<string> {
    this.exportToPdf();
    return of(null);
  }

  initializeExportDate(): void {
    const now = new Date();
    const options: Intl.DateTimeFormatOptions = { 
      year: 'numeric', 
      month: '2-digit', 
      day: '2-digit' 
    };
    this.exportDate = now.toLocaleDateString('en-US', options);
    
    const timeOptions: Intl.DateTimeFormatOptions = {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: 'America/New_York',
      timeZoneName: 'short'
    };
    this.exportTime = now.toLocaleTimeString('en-US', timeOptions);
  }

  initializeUserDescription(): void {
    const userDescription = this.wizard?.model?.userDescription;
    this.analysisDescription = userDescription || 'No description provided';
  }

  initializeStoreLegend(): void {
    const storeData = this.wizard?.model?.storeData || {};
    
    const allItems = [
      { label: 'Conventional', count: storeData['Conventional'] || 0 },
      { label: 'Natural Foods', count: storeData['Natural Foods'] || 0 },
      { label: 'Discount', count: storeData['Discount'] || 0 },
      { label: 'Whole Foods', count: storeData['Whole Foods'] || 0 },
      { label: 'Asian', count: storeData['Asian'] || 0 },
      { label: 'Hispanic', count: storeData['Hispanic'] || 0 },
      { label: 'Aldi', count: storeData['Aldi'] || 0 },
      { label: 'Supercenter', count: storeData['Supercenter'] || 0 },
      { label: 'Trader Joe\'s', count: storeData['Trader Joe\'s'] || 0 },
      { label: 'Warehouse', count: storeData['Warehouse'] || 0 },
      { label: 'Quality/Service', count: storeData['Quality/Service'] || 0 },
      { label: 'Club', count: storeData['Club'] || 0 },
      { label: 'Save A Lot', count: storeData['Save A Lot'] || 0 },
      { label: 'Sprouts', count: storeData['Sprouts'] || 0 }
    ];
    
    const filteredItems = allItems.filter(item => item.count > 0).map(item => `${item.label} (${item.count})`);
    
    this.storeLegendItems = filteredItems.slice(0, 7);
    this.storeLegendItemsSecondary = filteredItems.slice(7);
    
    this.initializeFilteredStores();
    this.initializeActiveFilters();
  }
  
  initializeActiveFilters(): void {
    const activeFilters = this.wizard?.model?.activeFilters || {};
    const cbsaName = this.wizard?.model?.cbsaName || 'Current Region';
    
    this.filterRegion = cbsaName;
    this.filterFits = activeFilters.fits || 'N/A';
    this.filterStatus = activeFilters.status || 'N/A';
    
    // Show active filters if any filters are applied
    this.showActiveFilters = activeFilters.hasAnyFilters || false;
    console.log('Show active filters:', this.showActiveFilters, 'Active filters:', activeFilters);
  }

  getActiveFilterEntries(): {label: string, value: string}[] {
    const activeFilters = this.wizard?.model?.activeFilters || {};
    const entries = [];
    
    const filterLabels = {
      region: 'Region',
      fits: 'FITs',
      status: 'Status',
      banner: 'Banner',
      area: 'Area',
      sales: 'Sales',
      collections: 'Collections'
    };
    
    Object.keys(filterLabels).forEach(key => {
      if (activeFilters[key] && activeFilters[key] !== 'N/A' && activeFilters[key] !== '') {
        entries.push({
          label: filterLabels[key],
          value: activeFilters[key]
        });
      }
    });
    
    // Add any other filters not in the predefined list
    Object.keys(activeFilters).forEach(key => {
      if (!filterLabels[key] && !['hasFitFilters', 'hasStatusFilters', 'hasAnyFilters'].includes(key)) {
        entries.push({
          label: key.charAt(0).toUpperCase() + key.slice(1),
          value: activeFilters[key]
        });
      }
    });
    
    return entries;
  }

  initializeMapCenterCoordinates(): void {
    const mapCenter = this.wizard?.model?.mapCenter;
    if (mapCenter) {
      this.centerPointLat = `${mapCenter.lat.toFixed(5)}N`;
      this.centerPointLong = `${Math.abs(mapCenter.lng).toFixed(5)}W`;
    }
  }
  
  initializeFilteredStores(): void {
    const storeList = this.wizard?.model?.storeList || [];
    const activeFilters = this.wizard?.model?.activeFilters || {};
    
    console.log('Store List:', storeList);
    console.log('Active Filters:', activeFilters);
    
    let filteredList = storeList;
    
    // Apply status filter (handle multiple statuses separated by commas)
    if (activeFilters.status !== '') {
      const selectedStatuses = activeFilters.status.split(', ').map((status: string) => status.trim().toUpperCase());
      filteredList = filteredList.filter((store1: any) => {
        const storeStatus = store1.store?.currentStatus?.type?.systemName?.toUpperCase();
        return selectedStatuses.includes(storeStatus);
      });
    }
    
    // Apply fit filter (handle multiple fits separated by commas)
    if (activeFilters.fits !== '') {
      const selectedFits = activeFilters.fits.split(', ').map((fit: string) => {
        return fit.trim().toUpperCase().replace(/\//g, '_').replace(/\s+/g, '_');
      });
      filteredList = filteredList.filter((store1: any) => {
        const storeFit = store1.store?.fit?.toUpperCase();
        return selectedFits.includes(storeFit);
      });
    }
    
    this.filteredStores = filteredList.map((store1: any) => {
      const rawFit = store1.store?.fit;
      // if empty/null/undefined → return "N/A" exactly as is
      const formattedFit = rawFit
    ? rawFit
        .replace(/_/g, ' ')
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    : 'N/A';

      return {
        storeName: store1.store?.name || 'N/A',
        banner: store1.store?.banner?.name || 'N/A',
        format: formattedFit,
        address: this.formatAddress(store1.store?.space?.location)
      };
    });
    
    console.log('Filtered Stores after applying filters:', this.filteredStores);
    this.totalStoreCount = this.filteredStores.length;
    this.checkPolygonAnalysis();
  }
  
  formatAddress(location: any): string {
    if (!location) return 'N/A';
    
    const parts = [];
    if (location.addressLine1) parts.push(location.addressLine1);
    if (location.city) parts.push(location.city);
    
    return parts.join(', ') || 'N/A';
  }

  getStoresPerPage(): number {
    return 21; // Max stores per page
  }

  getTotalPages(): number {
    const hasBothFiltersAndAnalysis = this.showActiveFilters && this.showPolygonAnalysis;
    const hasNeitherSection = !this.showActiveFilters && !this.showPolygonAnalysis;
    const tableStartPage = hasBothFiltersAndAnalysis ? 2 : 1;
    
    if (tableStartPage === 1) {
      const storesOnPage1 = hasNeitherSection ? 5 : 1;
      if (this.totalStoreCount > storesOnPage1) {
        const remainingStores = this.totalStoreCount - storesOnPage1;
        const additionalPages = Math.ceil(remainingStores / this.getStoresPerPage());
        return 1 + additionalPages;
      }
    }
    
    return Math.max(tableStartPage, Math.ceil(this.totalStoreCount / this.getStoresPerPage()) + (tableStartPage - 1));
  }

  getStoresForPage(pageNum: number): any[] {
    const hasBothFiltersAndAnalysis = this.showActiveFilters && this.showPolygonAnalysis;
    const hasNeitherSection = !this.showActiveFilters && !this.showPolygonAnalysis;
    const tableStartPage = hasBothFiltersAndAnalysis ? 2 : 1;
    
    if (pageNum === 1 && tableStartPage === 1) {
      // When both sections missing, show 5 stores; when only one section available, show 1 store
      const storesOnPage1 = hasNeitherSection ? 5 : 1;
      return this.filteredStores.slice(0, storesOnPage1);
    }
    
    const storesPerPage = this.getStoresPerPage();
    const adjustedPageNum = tableStartPage === 1 ? pageNum - 1 : pageNum - tableStartPage;
    const storesOnPage1 = hasNeitherSection ? 5 : 1;
    const startIndex = tableStartPage === 1 && pageNum > 1 ? storesOnPage1 + (adjustedPageNum - 1) * storesPerPage : adjustedPageNum * storesPerPage;
    const endIndex = startIndex + storesPerPage;
    return this.filteredStores.slice(startIndex, endIndex);
  }

  getAdditionalPages(): number[] {
    const totalPages = this.getTotalPages();
    const hasBothFiltersAndAnalysis = this.showActiveFilters && this.showPolygonAnalysis;
    const minPages = hasBothFiltersAndAnalysis ? 2 : 1;
    if (totalPages <= minPages) return [];
    const pages = [];
    for (let i = minPages + 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  }

  getFirstLineLegend(): string[] {
    const allItems = [...this.storeLegendItems, ...this.storeLegendItemsSecondary];
    return allItems.slice(0, 5);
  }

  getSecondLineLegend(): string[] {
    const allItems = [...this.storeLegendItems, ...this.storeLegendItemsSecondary];
    return allItems.slice(5);
  }

  setMapSnapshot(mapImage: string): void {
    this.capturedMapImage = mapImage;
    console.log('Map snapshot set in PDF component');
  }

  async captureMapBeforeExport() {
    // Get map image from global state if available
    const globalMapImage = (window as any).capturedMapImage;
    if (globalMapImage) {
      this.capturedMapImage = globalMapImage;
      console.log('Using map image from global state');
      return;
    }
    
    console.log('No map image found in global state');
  }

  async exportToPdf() {
    // Use the new dynamic PDF generation
    await this.exportToDynamicPdf();
  }

  /**
   * Export using the new dynamic PDF service (native jsPDF elements)
   * This is faster and produces better quality PDFs
   */
  async exportToDynamicPdf() {
    try {
      this.exportPdfButtonText = 'Capturing Map...';

      // Capture the current map state before generating PDF
      await this.captureCurrentMapState();

      this.exportPdfButtonText = 'Generating PDF...';

      // Prepare filter entries
      const filterEntries = this.getActiveFilterEntries().map(f => ({
        category: f.label || '',
        value: f.value || ''
      }));

      // Prepare store list
      const stores = this.filteredStores.map(store => ({
        name: store.storeName || store.name || '',
        banner: store.banner || '',
        fit: store.format || store.fit || '',
        address: store.address || ''
      }));

      // Prepare the full data object
      const pdfData: MapSearchPdfData = {
        exportDate: this.exportDate,
        exportTime: this.exportTime,
        userDescription: this.analysisDescription,
        mapImage: this.capturedMapImage || undefined,
        storeLegend: [...this.getFirstLineLegend(), ...this.getSecondLineLegend()],
        activeFilters: filterEntries,
        showPolygonAnalysis: this.showPolygonAnalysis,
        polygonAnalysis: this.showPolygonAnalysis ? {
          areaSquareFeet: this.areaSquareFeet || '--',
          areaAcres: this.areaAcres || '',
          perimeterFeet: this.perimeterFeet || '--',
          perimeterMiles: this.perimeterMiles || '',
          centerPointLat: this.centerPointLat || '--',
          centerPointLong: this.centerPointLong || ''
        } : undefined,
        stores
      };

      // Generate PDF using the dynamic service
      await this.dynamicPdfService.generateMapSearchPdf(pdfData, 'map-search-report.pdf');

      this.toaster.info('PDF exported successfully!');
    } catch (error) {
      console.error('PDF export failed:', error);
      this.toaster.error('Failed to export PDF: ' + error.message);
    } finally {
      this.exportPdfButtonText = 'Export PDF';
    }
  }

  /**
   * Export using the old html2canvas approach (for comparison/fallback)
   */
  async exportToPdfLegacy() {
    try {
      this.exportPdfButtonText = 'Capturing Current Map...';

      // Always capture the current map state before generating PDF
      await this.captureCurrentMapState();

      this.exportPdfButtonText = 'Generating PDF...';

      // Check if element exists
      const element = document.querySelector('#map-search-pdf-page-1');
      console.log('PDF Element found:', element);

      if (!element) {
        this.toaster.error('PDF content not found');
        return;
      }

      // Try the service first
      try {
        const pageSelectors = [['#map-search-pdf-page-1']];
        const hasBothFiltersAndAnalysis = this.showActiveFilters && this.showPolygonAnalysis;

        if (hasBothFiltersAndAnalysis) {
          pageSelectors.push(['#map-search-pdf-page-2']);
        }

        const additionalPages = this.getAdditionalPages();
        additionalPages.forEach(pageNum => {
          pageSelectors.push([`#map-search-pdf-page-${pageNum}`]);
        });

        await this.pdfExportService.exportToPdfWithPages(pageSelectors, 'map-search-report.pdf');

        this.toaster.info('PDF exported successfully');
      } catch (serviceError) {
        console.error('Service export failed, trying fallback:', serviceError);

        // Fallback: Direct implementation
        const jsPDF = (await import('jspdf')).default;
        const html2canvas = (await import('html2canvas')).default;

        const pdf = new jsPDF('p', 'mm', 'letter');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        // First page
        const canvas1 = await html2canvas(element as HTMLElement, {
          backgroundColor: '#ffffff',
          scale: 2,
          useCORS: true,
          allowTaint: true,
          logging: true
        });
        const imgData1 = canvas1.toDataURL('image/png', 1.0);
        pdf.addImage(imgData1, 'PNG', 0, 0, pageWidth, pageHeight);

        // Second page
        const element2 = document.querySelector('#map-search-pdf-page-2');
        if (element2) {
          pdf.addPage();
          const canvas2 = await html2canvas(element2 as HTMLElement, {
            backgroundColor: '#ffffff',
            scale: 2,
            useCORS: true,
            allowTaint: true,
            logging: true
          });
          const imgData2 = canvas2.toDataURL('image/png', 1.0);
          pdf.addImage(imgData2, 'PNG', 0, 0, pageWidth, pageHeight);
        }

        pdf.save('map-search-report.pdf');

        this.toaster.info('PDF downloaded successfully');
      }
    } catch (error) {
      console.error('PDF export failed completely:', error);
      this.toaster.error('Failed to export PDF: ' + error.message);
    } finally {
      this.exportPdfButtonText = 'Export PDF';
    }
  }
}
